module.exports = __webpack_public_path__ + "img/GS-Full-Brackets-Green-Black.45eeac68.png";